<script>
export default {
  name: "AutomatorErrorPage",
  data() {
    return {
      errors: [],
    };
  },
  methods: {
    update() {
      this.errors = AutomatorData.currentErrors();
    },
    scrollToLine(line) {
      AutomatorScroller.scrollToLine(line);
      AutomatorHighlighter.updateHighlightedLine(line, LineEnum.Error);
    }
  }
};
</script>

<template>
  <div class="c-automator-docs-page">
    <div v-if="errors.length === 0">
      Ошибок в скрипте не найдено!
    </div>
    <div v-else>
      <b>Ваш скрипт имеет следующие {{ ruQuantify("ошибку,ошибки,ошибок", errors.length) }}:</b>
      <br>
      <span
        v-for="(error, i) in errors"
        :key="i"
      >
        <b>На строке {{ error.startLine }}:</b>
        <button
          v-tooltip="'Перейти к строке'"
          class="c-automator-docs--button fas fa-arrow-circle-right"
          @click="scrollToLine(error.startLine)"
        />
        <div class="c-automator-docs-page__indented">
          {{ error.info }}
        </div>
        <div class="c-automator-docs-page__indented">
          <i>Рекомендуемый фикс: {{ error.tip }}</i>
        </div>
      </span>
      <i>
        Примечание: Иногда ошибки могут мешать Автоматизатору отсканировать оставшуюся часть скрипта.
        Это может привести к "исчезновению" некоторых ошибок, из-за того что другие ошибки случаются в более ранних
        строках, или ошибки в командах, которые имеют внутренний блок (например команды по типу IF или WHILE), приводя
        к тому, что ошибки появляются на корректно-форматированных позже командах. Также, некоторые из рекомендуемых
        фиксов могут вводить в заблуждение из-за неизвестной причины ошибки.
      </i>
    </div>
  </div>
</template>

<style scoped>

</style>
